<template >
    <el-row class="alltext" :style="{height:all_height}">
      <!-- <i class="el-icon-arrow-left" @click="back()" style="cursor: pointer;">返回</i> -->
      <el-row v-if="type_show=='first'">
        <h2 style="text-align: center;">测评系统组卷</h2>
        <el-col  :offset="2" :span="20" style="margin-top: 1.25rem;">
          <el-row >
              <span>试卷名称：<el-input style="width: 50%;" v-model="list.name" placeholder="请输入内容"></el-input></span>
          </el-row>
          <el-row>
            <h4 style="float: left;">试题选择</h4>
            <el-button round style="float: right;" @click="show_exam()">已选{{list.user_choice_all.length}}</el-button>
          </el-row>
          <el-row  class="exam">
            <el-tabs v-model="exam_choice.activeName" @tab-click="handleClick" id="exam" >
                <el-tab-pane label='测评题库' name='eval'>
                  <el-row v-if="exam_choice.exam_list.eval_list.length==0">
                    <el-table
                      ref="eval_table"
                      :data="exam_choice.exam_list.eval_list"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      :key="bomkey"
                      >
                      <el-table-column
                        type="selection"
                        width="55">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                       >
                       <template slot="header" slot-scope="scope">
                         <el-input
                           v-model="exam_choice.exam_list.eva.keyword"
                           @change="input_change()"
                           size="mini"
                           placeholder="输入题目关键字搜索"/>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                  <el-table
                  v-if="exam_choice.exam_list.eval_list.length!=0"
                    ref="eval_table"
                    :data="exam_choice.exam_list.eval_list"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :key="bomkey"
                    :height="first_height"
                    >
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                     >
                     <template slot="header" slot-scope="scope">
                       <el-input
                         v-model="exam_choice.exam_list.eva.keyword"
                         @change="input_change()"
                         size="mini"
                         placeholder="输入题目关键字搜索"/>
                      </template>
                    </el-table-column>
                  </el-table>
                   <el-pagination
                        class="fenye"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="exam_choice.exam_list.eva.currentPage"
                        :page-size="exam_choice.exam_list.eva.pageSize"
                        :page-sizes="[5, 10, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="exam_choice.exam_list.eva.total">
                      </el-pagination>
                </el-tab-pane>
                <el-tab-pane label='内部视频题库' name='video'>
                  <el-row v-if="exam_choice.exam_list.video_list.length==0">
                    <el-table
                      ref="video_table"
                      :data="exam_choice.exam_list.video_list"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      :key="bomkey_video"
                      >
                      <el-table-column
                        type="selection"
                        width="55">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                       >
                       <template slot="header" slot-scope="scope">
                         <el-input
                           v-model="exam_choice.exam_list.video.keyword"
                           @change="input_change()"
                           size="mini"
                           placeholder="输入题目关键字搜索"/>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                  <el-table
                  v-if="exam_choice.exam_list.video_list.length!=0"
                  :height="first_height"
                    ref="video_table"
                    :data="exam_choice.exam_list.video_list"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :key="bomkey_video"
                    >
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                     >
                     <template slot="header" slot-scope="scope">
                       <el-input
                         v-model="exam_choice.exam_list.video.keyword"
                         @change="input_change()"
                         size="mini"
                         placeholder="输入题目关键字搜索"/>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                     class="fenye"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="exam_choice.exam_list.video.currentPage"
                     :page-size="exam_choice.exam_list.video.pageSize"
                     :page-sizes="[5, 10, 50, 100]"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="exam_choice.exam_list.video.total">
                   </el-pagination>
                </el-tab-pane>
                <el-tab-pane label='内部文档题库' name='file'>
                  <el-row v-if="exam_choice.exam_list.file_list.length==0">
                    <el-table
                      ref="file_table"
                      :data="exam_choice.exam_list.file_list"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      :key="bomkey_file"
                      >
                      <el-table-column
                        type="selection"
                        width="55">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                       >
                       <template slot="header" slot-scope="scope">
                         <el-input
                           v-model="exam_choice.exam_list.file.keyword"
                           @change="input_change()"
                           size="mini"
                           placeholder="输入题目关键字搜索"/>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                  <el-table
                  v-if="exam_choice.exam_list.file_list.length!=0"
                  :height="first_height"
                    ref="file_table"
                    :data="exam_choice.exam_list.file_list"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :key="bomkey_file"
                    >
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                     >
                     <template slot="header" slot-scope="scope">
                       <el-input
                         v-model="exam_choice.exam_list.file.keyword"
                         @change="input_change()"
                         size="mini"
                         placeholder="输入题目关键字搜索"/>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                     class="fenye"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="exam_choice.exam_list.file.currentPage"
                     :page-size="exam_choice.exam_list.file.pageSize"
                     :page-sizes="[5, 10, 50, 100]"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="exam_choice.exam_list.file.total">
                   </el-pagination>
                </el-tab-pane>
              </el-tabs>
          </el-row>
          <el-row style="float: right;margin-top: 0.625rem;">
            <el-button type="primary" round @click="next(1)">下一步</el-button>
          </el-row>
        </el-col>
        <el-dialog
          title="已选题目"
          :visible.sync="first_dialogVisible"
          width="60%"
          class="exam"
          >
          <el-row v-if="list.user_choice_all.length==0">
            <el-empty description="暂无数据"></el-empty>
          </el-row>
          <el-table
          v-if="list.user_choice_all.length!=0"
            ref="multipleTable"
            :data="list.user_choice_all"
            tooltip-effect="dark"
            class="exam"
            height="250"
            >
            <el-table-column
              prop="name"

             >
             <!-- <template slot="header" slot-scope="scope">
               <el-input
                 v-model="exam_choice.search"
                 size="mini"
                 placeholder="输入题目关键字搜索"/>
              </template> -->
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="first_dialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
      </el-row>
      <el-row v-if="type_show=='tow'">
        <h2 style="text-align: center;">设置分数（满分100分）</h2>
        <el-col  :offset="2" :span="20" style="margin-top: 1.25rem;">
          <el-row  style="float: right;margin-bottom: 20px;">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary"  @click="average">一键设置平均分</el-button>
          </el-row>
        <el-row v-if="list.user_choice_all.length==0">
          <el-empty description="暂无数据"></el-empty>
        </el-row>
        <el-table
        v-if="list.user_choice_all.length!=0"
          ref="multipleTable"
          :data="list.user_choice_all"
          tooltip-effect="dark"
          class="exam"
          border
          :height="exam_heihgt"
          :row-class-name="tableRowClassName"
          @cell-click="tabClick"
          :key="num_key"
          >
          <el-table-column
            prop="name"
            label="题目"
           >
          </el-table-column>
          <el-table-column
                label="分值"
                width="180"
                prop="score"
                >
                <template slot-scope="scope">
                  <span v-if="scope.row.index === tabClickIndex ">
                    <el-input v-model="scope.row.score" type="number" maxlength="20" placeholder="请输入分数" size="mini" @blur="inputBlur(scope.row)" />
                  </span>
                  <span v-else>{{scope.row.score }}</span>
                </template>
              </el-table-column>
              <el-table-column
                    fixed="right"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                      <el-button @click="delete_exam(scope.row)" type="text" size="small" style="color: red;">删除</el-button>
                    </template>
                  </el-table-column>
        </el-table>
        <el-row style="margin-top: 2.5rem;">
          <el-button type="primary" round style="float: left; " @click="next(2)">上一步</el-button>
          <el-button type="primary" round style="float: right;" @click="next(3)">完 成</el-button>
        </el-row>
        </el-col>
      </el-row>

      <!-- <el-row v-if="type_show=='three'" >
        <h2 style="text-align: center;">选择审核人（注意：只能选择一人）</h2>
        <el-col  :offset="2" :span="20" style="margin-top: 1.25rem;">
          <el-row :style="{height:exam_heihgt}">
            <el-col :offset="1" :span="10" class="first_left">
              <el-row style="margin: 1.25rem;">
                <el-row style="float: right;">
                  <el-button type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
                  <el-button type="success" icon="el-icon-check" circle @click="per_click"></el-button>
                </el-row>
                <el-input  style="margin-top: 9px;" v-model="user_value" placeholder="请输入内容"></el-input> <br />
                <el-tree
                     show-checkbox
                     :data="list.user_list"
                     ref="treeper"
                     node-key="num"
                     :filter-node-method="filterNode"
                     :default-checked-keys="set_user_list.mr_xz_key"
                    :props="set_user_list.defaultProps">
                </el-tree>
              </el-row>
            </el-col>
            <el-col :offset="2" :span="10" class="first_left">
              <el-row style="margin: 1.25rem;">
                <span>您选择的是</span>
                <span style="float: right;">共{{set_user_list.xzper_list.length}}人</span>
                  <el-table
                      :data="set_user_list.xzper_list"
                      style="width: 100%">
                      <el-table-column
                        prop="name"
                        label="姓名">
                      </el-table-column>
                    </el-table>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-top: 2.5rem;">
            <el-button type="primary" round style="float: left; " @click="next(1)">上一步</el-button>
            <el-button type="primary" round style="float: right;" @click="next(4)">完 成</el-button>
          </el-row>
        </el-col>
      </el-row> -->
      <el-dialog
        title="注意"
        :visible.sync="exam_btn_dialogVisible"
        width="30%"
        >
        <span>一键设置平均分后，分数将无法更改</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exam_btn_dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="exam_btn()">确 定</el-button>
        </span>
      </el-dialog>

    </el-row>
</template>

<script>
  export default{
    watch: {
         user_value(val){
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
       },
    data(){
      return{
        types:'ed',//是编辑还是增加
        set_table_all_show:false,
        pageshow:{
          eval_list:true,
          eval_list_num:0,
          eval_list_num_add:0,
          video_list:true,
          video_list_num:0,
          video_list_num_add:0,
          file_list:true,
          file_list_num:0,
          file_list_num_add:0,
        },
        paged_status:0,
        set_info:0,
        set_info_all:0,
        user_value:"",
        set_user_list:{
          defaultProps: {
            children: 'children',
            label: 'name',
          },
          xzper_list:[],

        },
        exam_btn_dialogVisible:false,
        info_num:this.$route.query.num,
        input_show:true,
        bomkey:'',
        bomkey_video:'',
        bomkey_file:'',
        num_key:'',
        tabClickIndex:'',
        tabClickLabel:'',
        type_show:'first',
       all_height:'',
       exam_heihgt:'',
       first_height:'',
       next_show:'first',
       show_num:'0',
       first_dialogVisible:false,
       // show:'assembly',
       list:{
         name:'',
         user_list:[],
         user_choice:{
           eval_list:[],
           file_list:[],
           video_list:[],
         },
         user_choice_all:[]
       },
       exam_choice:{
         label:[
           {label:'测评题库',name:'eval'},
           {label:'内部视频题库',name:'video'},
           {label:'内部文档题库',name:'file'},
         ],
         activeName: 'eval',
         exam_list:{
           file_list:[],
           eval_list:[],
           video_list:[],
           eva:{
             currentPage: 1, // 当前页码
             total: 0, // 总条数
             pageSize:10,
             keyword:'',
           },
           file:{
               currentPage: 1, // 当前页码
               total: 0, // 总条数
               pageSize:10,
               keyword:'',
           },
           video:{
             currentPage: 1, // 当前页码
             total: 0, // 总条数
             pageSize:10,
             keyword:'',
           },
         },
       search:'',
       },
      }
    },
    mounted() {

      this.all_height=window.innerHeight + 'px'
      this.first_height=window.innerHeight * 0.4 + 'px'
      this.exam_heihgt=window.innerHeight * 0.55 + 'px'
      // if(this.info_num==''){
      //   this.$message.error('新增');
      // }else{
      //   this.$message.error('编辑');
      // }
      this.get_info();
      // this.set_user();

    },
    methods:{
      get_info(){
      let _this=this
        if(_this.info_num!=''){
          _this.show='false'
          _this.set_info=0
          _this.types='ed'
          _this.get_exam_info(_this.info_num)
        }else{
          _this.types='new'
          _this.get_subject("eva")
          _this.get_subject("video")
          _this.get_subject("file")
        }

      },
      get_exam_info(num){
        let _this=this
        _this.axios.get("/v2/c_evaluate/get_exam_info",{params: {num:num}}).then(function (res) {
          if(res.data.code=='1'){
            _this.list.name=res.data.data.name
            _this.list.user_choice.eval_list=res.data.data.subject.eva
            _this.list.user_choice.file_list=res.data.data.subject.file
            _this.list.user_choice.video_list=res.data.data.subject.video
            for(let i=0;i<_this.list.user_choice.eval_list.length;i++){
              let type=''
              if( _this.list.user_choice.eval_list[i].type=='0'){
                type='[选择题]--'
              }else{
                type='[判断题]--'
              }
              _this.list.user_choice.eval_list[i].name=type+_this.list.user_choice.eval_list[i].name
            }
            for(let i=0;i< _this.list.user_choice.file_list.length;i++){
              let type=''
              if(  _this.list.user_choice.file_list[i].type=='1'){
                type='[选择题]--'
              }else{
                type='[判断题]--'
              }
               _this.list.user_choice.file_list[i].name=type+ _this.list.user_choice.file_list[i].name
            }
            for(let i=0;i<_this.list.user_choice.video_list.length;i++){
              let type=''
              if(_this.list.user_choice.video_list[i].type=='1'){
                type='[选择题]--'
              }else{
                type='[判断题]--'
              }
             _this.list.user_choice.video_list[i].name=type+ _this.list.user_choice.video_list[i].name
            }
            _this.paged_status=res.data.data.subject.eva.length+res.data.data.subject.file.length+res.data.data.subject.video.length

            if(_this.list.user_choice.eval_list.length>0){
              _this.info_set_name('eval_list')
            }
             if(_this.list.user_choice.file_list.length>0){
              _this.info_set_name('file_list')
            }
             if(_this.list.user_choice.video_list.length>0){
              _this.info_set_name('video_list')
            }
            _this.list.user_choice_all=_this.list.user_choice.eval_list.concat(_this.list.user_choice.video_list,_this.list.user_choice.file_list)
            _this.set_info_all=_this.list.user_choice_all.length
            _this.next_show='tow'
            _this.show='tow'
            _this.get_subject_first("eva")
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      info_set_name(type){
          for(let i=0;i<this.list.user_choice[type].length;i++){
              if(type=='eval_list'){
                this.list.user_choice[type][i]['type']='eva'
              }else if(type=='file_list'){
                this.list.user_choice[type][i]['type']='file'
              }else{
                this.list.user_choice[type][i]['type']='video'
              }
        }
      },
      exam_btn(){
        this.exam_btn_dialogVisible=false
        this.input_show=false
        const r = /^\+?[1-9][0-9]*$/; // 正整数
        if(!r.test( 100/this.list.user_choice_all.length) ){
          this.$message.error('题目数无法被100整除，无法设置平均分，');
        }else{
          for(let i=0;i<this.list.user_choice_all.length;i++){
            this.list.user_choice_all[i]['score']=100/this.list.user_choice_all.length
          }
          this.num_key++
        }
      },
      average(){
        this.exam_btn_dialogVisible=true

      },
      cancel(){
      this.input_show=true
      for(let i=0;i<this.list.user_choice_all.length;i++){
        this.$delete(this.list.user_choice_all[i],'score')
      }
      this.num_key++
      },
      delete_exam(item){
        this.delete_exam_item('video_list',item)
        this.delete_exam_item('file_list',item)
        this.delete_exam_item('eval_list',item)
      },
      delete_exam_item(type,val){
        let _this=this
          for(let j=0;j<_this.list.user_choice[type].length;j++){
            if(val.num==_this.list.user_choice[type][j].num){
              _this.list.user_choice[type].splice(j,1)
          }
        }
        _this.show_num=_this.list.user_choice.video_list.length+_this.list.user_choice.file_list.length+_this.list.user_choice.eval_list.length
        _this.list.user_choice_all=_this.list.user_choice.eval_list.concat(_this.list.user_choice.video_list,_this.list.user_choice.file_list)
      },
      input_change(){
        this.paged_status=true
        if(this.exam_choice.activeName=='video'){
          this.exam_choice.exam_list.video.pageSize=Number(10)
          this.exam_choice.exam_list.video.currentPage=1
          this.pageshow.video_list=true
        }else if(this.exam_choice.activeName=='file'){
          this.exam_choice.exam_list.file.pageSize=Number(10)
          this.exam_choice.exam_list.file.currentPage=1
          this.pageshow.file_list=true
        }else if(this.exam_choice.activeName=='eval'){
          this.exam_choice.exam_list.eva.pageSize=Number(10)
          this.exam_choice.exam_list.eva.currentPage=1
          this.pageshow.eval_list=true
        }
        this.get_subject(this.exam_choice.activeName)
      },
      //分页
      handleSizeChange(val){
        this.paged_status=true
          if(this.exam_choice.activeName=='video'){
            this.exam_choice.exam_list.video.pageSize=Number(val)
            this.pageshow.video_list=true
          }else if(this.exam_choice.activeName=='file'){
            this.exam_choice.exam_list.file.pageSize=Number(val)
            this.pageshow.file_list=true
          }else if(this.exam_choice.activeName=='eval'){
            this.exam_choice.exam_list.eva.pageSize=Number(val)
            this.pageshow.eval_list=true
          }
          this.get_subject(this.exam_choice.activeName)

      },
       handleCurrentChange(val) {
         this.paged_status=true
            if(this.exam_choice.activeName=='video'){
              this.exam_choice.exam_list.video.currentPage=val
              this.pageshow.video_list=true
            }else if(this.exam_choice.activeName=='file'){
              this.exam_choice.exam_list.file.currentPage=val
              this.pageshow.file_list=true
            }else if(this.exam_choice.activeName=='eval'){
              this.exam_choice.exam_list.eva.currentPage=val
              this.pageshow.eval_list=true
            }
            this.get_subject(this.exam_choice.activeName)

       },
       get_subject_first(type){
         let _this=this
         let  evals=false
         let  videos=false
         let  files=false

         if(type=="eval"){
           type='eva'
         }
           _this.axios.get("/v2/c_evaluate/get_subject",{params: {
             type:type,
             page:_this.exam_choice.exam_list[type].currentPage,
             limit:Number(_this.exam_choice.exam_list[type].pageSize) ,
             keyword:_this.exam_choice.exam_list[type].keyword
           }}).then(function (res) {
             if(res.data.code=='1'){
                _this.$nextTick(()=>{
                  if(type=='eva'){
                    _this.exam_choice.exam_list.eval_list=res.data.data.data
                    for(let i=0;i<_this.exam_choice.exam_list.eval_list.length;i++){
                      let type=''
                      if( _this.exam_choice.exam_list.eval_list[i].type=='0'){
                        type='[选择题]--'
                      }else{
                        type='[判断题]--'
                      }
                      _this.exam_choice.exam_list.eval_list[i].name=type+_this.exam_choice.exam_list.eval_list[i].name
                    }
                    _this.exam_choice.exam_list.eva.currentPage=res.data.data.current_page
                    _this.exam_choice.exam_list.eva.pageSize=Number(res.data.data.per_page)
                    _this.exam_choice.exam_list.eva.total=res.data.data.total
                    _this.bomkey++
                    evals=true
                    _this.get_subject_first("video")


                  }else if(type=='video'){
                    _this.exam_choice.exam_list.video_list=res.data.data.data
                    for(let i=0;i<_this.exam_choice.exam_list.video_list.length;i++){
                      let type=''
                      if( _this.exam_choice.exam_list.video_list[i].type=='1'){
                        type='[选择题]--'
                      }else{
                        type='[判断题]--'
                      }
                      _this.exam_choice.exam_list.video_list[i].name=type+_this.exam_choice.exam_list.video_list[i].name
                    }
                    _this.exam_choice.exam_list.video.currentPage=res.data.data.current_page
                    _this.exam_choice.exam_list.video.pageSize=Number(res.data.data.per_page)
                    _this.exam_choice.exam_list.video.total=res.data.data.total
                    _this.bomkey_video++
                    videos=true
                    _this.get_subject_first("file")
                  }else{
                    _this.exam_choice.exam_list.file_list=res.data.data.data
                    for(let i=0;i<_this.exam_choice.exam_list.file_list.length;i++){
                      let type=''
                      if( _this.exam_choice.exam_list.file_list[i].type=='1'){
                        type='[选择题]--'
                      }else{
                        type='[判断题]--'
                      }
                      _this.exam_choice.exam_list.file_list[i].name=type+ _this.exam_choice.exam_list.file_list[i].name
                    }
                    _this.exam_choice.exam_list.file.currentPage=res.data.data.current_page
                    _this.exam_choice.exam_list.file.pageSize=Number(res.data.data.per_page)
                    _this.exam_choice.exam_list.file.total=res.data.data.total
                    _this.bomkey_file++
                    files=true
                    _this.set_table()

                  }

                })
             }else{
               _this.$message.error(res.data.msg)
             }
           })
       },
      get_subject(type){
        let _this=this
        let  evals=false
        let  videos=false
        let  files=false

        if(type=="eval"){
          type='eva'
        }
          _this.axios.get("/v2/c_evaluate/get_subject",{params: {
            type:type,
            page:_this.exam_choice.exam_list[type].currentPage,
            limit:Number(_this.exam_choice.exam_list[type].pageSize) ,
            keyword:_this.exam_choice.exam_list[type].keyword
          }}).then(function (res) {
            if(res.data.code=='1'){
               _this.$nextTick(()=>{
                 if(type=='eva'){
                   _this.exam_choice.exam_list.eval_list=res.data.data.data
                   for(let i=0;i<_this.exam_choice.exam_list.eval_list.length;i++){
                     let type=''
                     if( _this.exam_choice.exam_list.eval_list[i].type=='0'){
                       type='[选择题]--'
                     }else{
                       type='[判断题]--'
                     }
                     _this.exam_choice.exam_list.eval_list[i].name=type+_this.exam_choice.exam_list.eval_list[i].name
                   }
                   _this.exam_choice.exam_list.eva.currentPage=res.data.data.current_page
                   _this.exam_choice.exam_list.eva.pageSize=Number(res.data.data.per_page)
                   _this.exam_choice.exam_list.eva.total=res.data.data.total
                   _this.bomkey++
                   evals=true

                 }else if(type=='video'){
                   _this.exam_choice.exam_list.video_list=res.data.data.data
                   for(let i=0;i<_this.exam_choice.exam_list.video_list.length;i++){
                     let type=''
                     if( _this.exam_choice.exam_list.video_list[i].type=='1'){
                       type='[选择题]--'
                     }else{
                       type='[判断题]--'
                     }
                     _this.exam_choice.exam_list.video_list[i].name=type+_this.exam_choice.exam_list.video_list[i].name
                   }
                   _this.exam_choice.exam_list.video.currentPage=res.data.data.current_page
                   _this.exam_choice.exam_list.video.pageSize=Number(res.data.data.per_page)
                   _this.exam_choice.exam_list.video.total=res.data.data.total
                   _this.bomkey_video++
                   videos=true
                 }else{
                   _this.exam_choice.exam_list.file_list=res.data.data.data
                   for(let i=0;i<_this.exam_choice.exam_list.file_list.length;i++){
                     let type=''
                     if( _this.exam_choice.exam_list.file_list[i].type=='1'){
                       type='[选择题]--'
                     }else{
                       type='[判断题]--'
                     }
                     _this.exam_choice.exam_list.file_list[i].name=type+ _this.exam_choice.exam_list.file_list[i].name
                   }
                   _this.exam_choice.exam_list.file.currentPage=res.data.data.current_page
                   _this.exam_choice.exam_list.file.pageSize=Number(res.data.data.per_page)
                   _this.exam_choice.exam_list.file.total=res.data.data.total
                   _this.bomkey_file++
                   files=true

                 }
                 _this.set_table()
               })
            }else{
              _this.$message.error(res.data.msg)
            }
          })
      },
      tableRowClassName ({ row, rowIndex }) {
            row.index = rowIndex
      },
      tabClick (row, column, cell, event) {
        if(this.input_show){
          this.tabClickIndex = row.index
          this.tabClickLabel = column.label
        }

      },
      inputBlur (row) {
            this.tabClickIndex = null
            this.tabClickLabel = ''
      },
      //下一步
      next(type){
        let _this=this
        if(type==1){
          if(_this.list.name=='' || _this.list.user_choice_all.length==0){
            _this.$message.error('试卷名称为空或选题为0');
          }else{
            _this.type_show='tow'
          }
        }else if(type==2){
          _this.type_show='first'
          _this.next_show='tow'
          _this.exam_choice.activeName='eval'
          _this.set_table()
        }else if(type==3){
          _this.get_exam()
        }else if(type==4){
          if(_this.set_user_list.xzper_list.length==0){
            _this.$message.error('必须选择一个审核员');
          }else{
            let data={
              name:_this.list.name,
              list:_this.list.user_choice_all,
              auditor:_this.set_user_list.xzper_list
            }
          }
        }
      },
      get_exam(){
        let _this=this
        let exam=0
        let show=true
        for(let i=0;i<_this.list.user_choice_all.length;i++){
          if(_this.list.user_choice_all[i]["score"]==undefined || _this.list.user_choice_all[i].score=='' ||_this.list.user_choice_all[i].score==0){
                _this.$message.error('分值不能为空或分数为0哦！');
                show=false
                return

          }else{
            exam=exam+_this.list.user_choice_all[i].score*1
          }
        }
        if(show){
          if(exam>100){
            _this.$message.error('分值总和不能超过100！');
          }else if(exam<100){
            _this.$message.error('分值总和不能小于100！');
          }else{
            // _this.$router.push({path:'/eva_list'});
            // _this.type_show='three'
            let data={
              name:_this.list.name,
              list:_this.list.user_choice_all,
            }
            if(_this.info_num!=''){
              data.num=_this.info_num
             _this.update_exam(data)
            }else{
              _this.save_exam(data)
            }

          }
        }
      },
      save_exam(data){
        let _this=this
        _this.axios.post("/v2/c_evaluate/save_exam",{data:data}).then(function (res) {
          if(res.data.code=='1'){
            _this.$message.success(res.data.msg)
            _this.$router.push({path:'/eva_list'});
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      update_exam(data){
        let _this=this
        _this.axios.post("/v2/c_evaluate/update_exam",{data:data}).then(function (res) {
          if(res.data.code=='1'){
            _this.$message.success(res.data.msg)
            _this.$router.push({path:'/eva_list'});
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },
      set_user(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_companyee_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list.user_list=res.data.data
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      removeper(){
        let _this=this;
        _this.set_user_list.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
      per_click() {
        let a=this.$refs.treeper.getCheckedNodes();
        this.set_user_list.xzper_list=[];
        let j=0;
        for(let i=0;i<a.length;i++){
          if(a[i].hasOwnProperty('s_id')){
            this.$set(this.set_user_list.xzper_list,j,a[i])
            j++;
          }
        }
        if(this.set_user_list.xzper_list.length!=1){
          this.removeper()
          this.$message.warning('注意：审核人只能选择一个');
        }
      },
      set_table(){
        let _this=this
        _this.$nextTick(()=>{

          let lists=_this.list.user_choice
          if(lists.video_list){
            lists.video_list.forEach(row => {
              _this.exam_choice.exam_list.video_list.forEach(item=>{
            	if(item.num == row.num){
            		_this.$refs.video_table.toggleRowSelection(item,true);
                _this.pageshow.video_list_num++
                _this.pageshow.video_list=true
            	}
              })
            })
          }
        	if(lists.eval_list ){
            lists.eval_list.forEach(row => {
            _this.exam_choice.exam_list.eval_list.forEach(item=>{
          	if(item.num == row.num){
          		_this.$refs.eval_table.toggleRowSelection(item,true);
              _this.pageshow.eval_list_num++
              _this.pageshow.eval_list=true
          	}
            })
          })
          }
          if(lists.file_list ){
          lists.file_list.forEach(row => {
            _this.exam_choice.exam_list.file_list.forEach(item=>{
          	if(item.num == row.num){
          		_this.$refs.file_table.toggleRowSelection(item,true);
              _this.pageshow.file_list_num++
              _this.pageshow.file_list=true
          	}
            })
          })
          }
          _this.next_show='first'
          // _this.paged_status=false
         })

      },
      //已选题目弹窗展示
      show_exam(){
        this.first_dialogVisible=true
      },
       //组卷
        handleSelectionChange(val) {
          let _this=this
          for(let i=0;i<val.length;i++){
            if(_this.exam_choice.activeName=='eval'){
              val[i]['type']='eva'
            }else{
              val[i]['type']=_this.exam_choice.activeName
            }
          }
          if(_this.next_show=='first'){
            if(_this.exam_choice.activeName=='video'){
            _this.set_table_name('video_list',val)
            }else if(_this.exam_choice.activeName=='file'){
              _this.set_table_name('file_list',val)
            }else if(_this.exam_choice.activeName=='eval'){
              _this.set_table_name('eval_list',val)
            }
            _this.list.user_choice_all=[]
            _this.show_num=_this.list.user_choice.video_list.length+_this.list.user_choice.file_list.length+_this.list.user_choice.eval_list.length
            _this.list.user_choice_all=_this.list.user_choice.eval_list.concat(_this.list.user_choice.video_list,_this.list.user_choice.file_list)
            _this.paged_status=_this.list.user_choice_all.length
         }
        },
       set_table_name(type,val){
         let _this=this
         if(_this.info_num!=''){
           if(_this.pageshow[type]){
             _this.$nextTick(()=>{
               _this.pageshow[type+'_num_add']++
               if(_this.pageshow[type]=='eval_list'){
                 if(_this.pageshow[type+'_num']== _this.pageshow[type+'_num_add']){
                   _this.pageshow[type]=false
                   _this.pageshow[type+'_num_add']=0
                   _this.pageshow[type+'_num']=0
                 }
               }else if(_this.pageshow[type]=='file_list'){
                 if(_this.pageshow[type+'_num']== _this.pageshow[type+'_num_add']){
                   _this.pageshow[type]=false
                   _this.pageshow[type+'_num_add']=0
                   _this.pageshow[type+'_num']=0
                 }
               }else{
                 if(_this.pageshow[type+'_num']== _this.pageshow[type+'_num']){
                   _this.pageshow[type]=false
                   _this.pageshow[type+'_num_add']=0
                   _this.pageshow[type+'_num']=0
                 }
               }
              })
           }else{
             if(val.length==0){
               for(let i=0;i<_this.exam_choice.exam_list[type].length;i++){
                 for(let j=0;j<_this.list.user_choice[type].length;j++){
                   if(_this.exam_choice.exam_list[type][i].num==_this.list.user_choice[type][j].num){
                     _this.list.user_choice[type].splice(j,1)
                   }
                 }
               }
             }
             // if(_this.paged_status==_this.list.user_choice_all.length){
               let b_remove = _this.exam_choice.exam_list[type].filter((item) => {
                   if (val.indexOf(item) < 0) {
                      for(var i=0;i<_this.list.user_choice[type].length;i++){
                        if(_this.list.user_choice[type][i].num==item.num){
                          _this.list.user_choice[type].splice(i,1)
                        }
                      }
                   }
                });
             // }

              let b_add = _this.exam_choice.exam_list[type].filter((item) => {
                      if (val.indexOf(item) >-1) {
                        var check=0
                        for(var i=0;i<_this.list.user_choice[type].length;i++){
                          if(_this.list.user_choice[type][i].num==item.num){
                            check++
                          }
                        }
                        if(check==0){
                           _this.list.user_choice[type]=_this.list.user_choice[type].concat(item)
                        }
                      }
               });
           }
         }else{
           if(val.length==0){
             for(let i=0;i<_this.exam_choice.exam_list[type].length;i++){
               for(let j=0;j<_this.list.user_choice[type].length;j++){
                 if(_this.exam_choice.exam_list[type][i].num==_this.list.user_choice[type][j].num){
                   _this.list.user_choice[type].splice(j,1)
                 }
               }
             }
           }
           // if(_this.paged_status==_this.list.user_choice_all.length){
             let b_remove = _this.exam_choice.exam_list[type].filter((item) => {
                 if (val.indexOf(item) < 0) {
                    for(var i=0;i<_this.list.user_choice[type].length;i++){
                      if(_this.list.user_choice[type][i].num==item.num){
                        _this.list.user_choice[type].splice(i,1)
                      }
                    }
                 }
              });
           // }

            let b_add = _this.exam_choice.exam_list[type].filter((item) => {
                    if (val.indexOf(item) >-1) {
                      var check=0
                      for(var i=0;i<_this.list.user_choice[type].length;i++){
                        if(_this.list.user_choice[type][i].num==item.num){
                          check++
                        }
                      }
                      if(check==0){
                         _this.list.user_choice[type]=_this.list.user_choice[type].concat(item)
                      }
                    }
             });
         }
       },
       back(){
         this.$router.push({path:'/eva_list'});
       },
       handleClick(tab, event) {
         let _this=this
         // if(tab.index==0){
         //   if(_this.list.user_choice.eval_list.length!=0){
         //     _this.set_table()
         //   }
         // }else if(tab.index==1){
         //   console.log(_this.list.user_choice.video_list)
         //   if(_this.list.user_choice.video_list.length!=0){
         //     _this.set_table()
         //   }
         // }else{
         //   if(_this.list.user_choice.file_list.length!=0){
         //     _this.set_table()
         //   }
         // }
         // _this.paged_status=true


        },
       filterNode(value, data) {
           if (!value) return true;
            return data.name.indexOf(value) !== -1;
       },
    },
    destroyed() {
        _this.pageshow={
          eval_list:true,
          eval_list_num:0,
          eval_list_num_add:0,
          video_list:true,
          video_list_num:0,
          video_list_num_add:0,
          file_list:true,
          file_list_num:0,
          file_list_num_add:0,
        }
     },
  }
</script>

<style scoped>
  .first_left{
    overflow-x: auto;
    border:1px solid 	#9D9D9D;
    border-radius: 5%;
    height: 100%;
    margin-top: 1.25rem;
  }
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
  .alltext{
    background-color: white;

  }
  .right{
     border: 2px solid red;
     border-radius: 5px;
     width: 100%;
  }
  .exam{
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/test_paper/test_assembly_edit.vue